// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-box_Box__z\\+qyK {
  position: absolute;
  /* Reference: 724x542 at 1536x864 screen, positioned at left:406, top:201 */
  /* Convert to viewport percentages for responsiveness */
  width: 47.135vw;
  /* 724 / 1536 * 100 */
  height: 62.731vh;
  /* 542 / 864 * 100 */
  max-width: 724px;
  max-height: 542px;
  min-width: 300px;
  min-height: 400px;

  /* Position: left:406px, top:201px at 1536x864 */
  top: 23.264vh;
  /* 201 / 864 * 100 */
  left: 26.432vw;
  /* 406 / 1536 * 100 */
  transform: none;

  background-color: #9DD102;
  padding: clamp(20px, 3.255vw, 50px);
  /* Responsive padding */

  /* border: 1px solid rgba(255, 255, 255, 0.3); */
  border-radius: clamp(25px, 3.255vw, 50px);
  /* Responsive border-radius */
  box-shadow:
    10px 10px 50px 0px #273400 inset,
    -10px -10px 50px 0px #273400 inset;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: clamp(10px, 1.5vh, 20px);
  /* Responsive gap between elements */
}

/* Scale inner elements responsively */
.login-box_Box__z\\+qyK>* {
  max-width: 100%;
}

@media (max-width: 1024px) {
  .login-box_Box__z\\+qyK {
    /* Center on smaller screens */
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    max-width: 500px;
    height: auto;
    min-height: 400px;
    padding: 30px;
  }
}

@media (max-width: 768px) {
  .login-box_Box__z\\+qyK {
    width: 90%;
    max-width: 400px;
    min-height: 350px;
    padding: 25px;
    border-radius: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/UI/common/Boxes/login-box.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,2EAA2E;EAC3E,uDAAuD;EACvD,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;;EAEjB,gDAAgD;EAChD,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,eAAe;;EAEf,yBAAyB;EACzB,mCAAmC;EACnC,uBAAuB;;EAEvB,gDAAgD;EAChD,yCAAyC;EACzC,6BAA6B;EAC7B;;sCAEoC;;EAEpC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA,sCAAsC;AACtC;EACE,eAAe;AACjB;;AAEA;EACE;IACE,8BAA8B;IAC9B,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;EACrB;AACF","sourcesContent":[".Box {\n  position: absolute;\n  /* Reference: 724x542 at 1536x864 screen, positioned at left:406, top:201 */\n  /* Convert to viewport percentages for responsiveness */\n  width: 47.135vw;\n  /* 724 / 1536 * 100 */\n  height: 62.731vh;\n  /* 542 / 864 * 100 */\n  max-width: 724px;\n  max-height: 542px;\n  min-width: 300px;\n  min-height: 400px;\n\n  /* Position: left:406px, top:201px at 1536x864 */\n  top: 23.264vh;\n  /* 201 / 864 * 100 */\n  left: 26.432vw;\n  /* 406 / 1536 * 100 */\n  transform: none;\n\n  background-color: #9DD102;\n  padding: clamp(20px, 3.255vw, 50px);\n  /* Responsive padding */\n\n  /* border: 1px solid rgba(255, 255, 255, 0.3); */\n  border-radius: clamp(25px, 3.255vw, 50px);\n  /* Responsive border-radius */\n  box-shadow:\n    10px 10px 50px 0px #273400 inset,\n    -10px -10px 50px 0px #273400 inset;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: clamp(10px, 1.5vh, 20px);\n  /* Responsive gap between elements */\n}\n\n/* Scale inner elements responsively */\n.Box>* {\n  max-width: 100%;\n}\n\n@media (max-width: 1024px) {\n  .Box {\n    /* Center on smaller screens */\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: 80%;\n    max-width: 500px;\n    height: auto;\n    min-height: 400px;\n    padding: 30px;\n  }\n}\n\n@media (max-width: 768px) {\n  .Box {\n    width: 90%;\n    max-width: 400px;\n    min-height: 350px;\n    padding: 25px;\n    border-radius: 30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Box": `login-box_Box__z+qyK`
};
export default ___CSS_LOADER_EXPORT___;
